export const FILE_ID_LENGTH = 26;

export const isTimeInternalFileLink = (link: string, siteUrl?: string) => {
    const decodedLink = decodeURIComponent(link);

    return Boolean(siteUrl && decodedLink.includes(siteUrl) && (
        decodedLink.includes('api/v4/image?url=') ||
        decodedLink.includes('api/v4/files')
    ));
};

export const getFileIdFromTimeInternalLink = (link: string) => {
    const decodedLink = decodeURIComponent(link);

    return decodedLink.substring(decodedLink.length - FILE_ID_LENGTH);
};
